const angular = window.angular;

import { BlockChart } from "./charts/block_chart";
import { detailScreeningFund, getJson } from "./search_common_detail";

let block_charts_option_list = [];
let block_charts_data_list = [];

function initOptionJson($scope, scope) {
  $scope.waitCallBackNum = 3;
  $scope.waitCallBackCnt = 0;
  $scope.showResultValFlag = false; // finish init_condition() after change val
  $scope.optionId = [];
  $scope.optionName = [];
  $scope.optionVal = [];
}
function init_scope($scope, scope) {
  // firefox is very slowly that use angular.copy
  $scope.optionJson = angular.copy(scope.optionJson); // all_clear use
  $scope.fundJson = scope.fundJson; //angular.copy(scope.fundJson);
  $scope.getSellBankJson = scope.getSellBankJson; //angular.copy(scope.getSellBankJson);
  // scope.getSellBankJson; //
  // scope.fundJson; //
  $scope.allSellBankJson = [];
  $scope.fundSellBankJson = [];
  $scope.sell_bank_type_json = [];
  $scope.getCompanyJson = [];
  if ($scope.getSellBankJson.length > 1) {
    $scope.allSellBankJson = $scope.getSellBankJson[0];
    $scope.fundSellBankJson = $scope.getSellBankJson[1];
    $scope.sell_bank_type_json = $scope.getSellBankJson[2];
    $scope.getCompanyJson = $scope.getSellBankJson[3];
  }
  $scope.allCompanyJson = [];
  $scope.company_type_json = [];
  if ($scope.getCompanyJson.length > 1) {
    $scope.allCompanyJson = $scope.getCompanyJson[0];
    $scope.company_type_json = $scope.getCompanyJson[1];
  }

  $scope.screeningFundJson = [];
  $scope.screeningResultFundJson = []; // 該当検索条件で結果

  initOptionData($scope);

  $scope.sell_bank_exist = [];
  $scope.company_exist = [];
}

function initOptionData($scope) {
  $scope.optionData = {
    id_list: [],
    name_list: [],
    item_list: [], // option item message
    item_num_list: [], // option item data-num
  }; // show data in html with cond & json
}

// Click '検索条件を変更' on the search results page to initialize the search conditions
function init_condition($scope) {
  // Get page data
  let option_list = $('.search_form input[name="option_list"]').val();
  let data_list_p = $('.search_form input[name="data_list"]').val();
  // init select chart パフォーマンス（1年）and 運用期間が1年未満
  if (option_list == "") {
    option_list = "1301,1401,1501,1701";
    data_list_p = "[0,1,2,3,4],[0,1,2,3,4],[0,1,2,3,4],[1]";
  }
  if (option_list !== "") {
    // Process the data, turn the string into an array
    option_list = option_list.split(",");
    data_list_p = data_list_p.split("],");
    let data_list = [];
    $.each(data_list_p, function (i, data) {
      data_list.push(data.replace("[", "").replace("]", "").split(","));
    });

    // Traverse option_list, simulate the click event, and initialize the condition
    let option_id_idx = -1;
    $.each($scope.optionJson, function (i, option) {
      option_id_idx = option_list.indexOf(String(option.option_id));
      if (option_id_idx > -1) {
        // 販売会社、運用会社
        if ([24, 25].indexOf(i) > -1) {
          let bank_type = "company";
          if (i === 25) bank_type = "sell_bank";
          $.each($scope[bank_type + "_type_json"], function (j, t_data) {
            $.each(t_data.data, function (j, data) {
              if (data_list[option_id_idx].indexOf(String(data.id)) > -1) {
                sell_bank_i($scope, data, bank_type); //add class
              }
            });
          });
          sell_list_search($scope, bank_type);
          return;
        }
        // chart click
        if ([13, 14, 15, 16, 17, 18, 19, 20, 21].indexOf(i) > -1) {
          block_charts_option_list = option_list;
          block_charts_data_list = data_list;
        }
        if ([26, 28, 29].indexOf(i) > -1) {
          check_less_year($scope, i);
        }
        // check box click
        $.each(option.data, function (j, data) {
          if (data_list[option_id_idx].indexOf(String(data.id)) > -1) {
            check_box_click(i, data, $scope);
          }
        });
      }
    });
  }
  $scope.showResultValFlag = true;
  showResultVal($scope);
}

// angular js
let search_detail_app = angular.module("search_detail", []);
// get json data
search_detail_app.factory("scope", [
  function () {
    let scope = {};
    scope.fundJson = [];
    scope.optionJson = [];
    scope.getSellBankJson = [];
    scope.getCompanyJson = [];
    return scope;
  },
]);

function afterJsonCallback(params) {
  let $scope = params.p1;
  let scope = params.p2;
  $scope.waitCallBackCnt += 1;
  if ($scope.waitCallBackCnt == $scope.waitCallBackNum) {
    init_scope($scope, scope);
    init_condition($scope);
    $scope.$apply(function () {
      scopePageRepeat($scope);
    });
    commonInit(params.p1, params.p2);
  }
}

// page show
function scopePageRepeat($scope) {
  $scope.page_repeat = function (num) {
    let data = $scope.optionJson[num].data;
    if ([5, 6, 27].indexOf(num) > -1) {
      $.each(data, function (i) {
        if (data[i].class === undefined) data[i].class = "";
      });
    }
    return data;
  };
}

function commonInit($scope, scope) {
  // radio check function
  $scope.check_box_click = function (ind, data) {
    check_box_click(ind, data, $scope);
  };
  $scope.sell_select_open = function (bank_type) {
    sell_select_open($scope, bank_type);
  };
  $scope.return_btn = function (bank_type) {
    clearSellBankAndCompany($scope, bank_type);
    $(".detail_company_popup").hide();
    sell_bank_push($scope, bank_type);
  };
  $scope.sell_select_search = function (bank_type) {
    let data = {};
    for (let j = 0; j < $scope[bank_type + "_select"].length; j++) {
      if (
        $scope[bank_type + "_select_val"] ===
        $scope[bank_type + "_select"][j].bank_id
      ) {
        data = {
          id: $scope[bank_type + "_select_val"],
          name: $scope[bank_type + "_select"][j].bank_name,
        };
        break;
      }
    }
    sell_select_search($scope, data, bank_type, true);
  };
  $scope.del_sell_bank_name = function (data, bank_type) {
    del_bank_name($scope, bank_type, data);
  };
  $scope.modal_show = function (id) {
    $("#" + id).show();
  };
  $scope.sell_bank_modal_p = function (data) {
    if (data.ul_class === undefined || data.ul_class === "hidden") {
      data.ul_class = "show";
      data.p_style = "border-bottom: 1px solid #cccccc;";
      data.brd_bottom_class = "brd_bottom";
    } else {
      data.ul_class = "hidden";
      data.p_style = "border-bottom: none;";
      data.brd_bottom_class = "";
    }
  };
  $scope.sell_bank_i = function (data, bank_type) {
    sell_bank_i($scope, data, bank_type);
  };
  $scope.sell_list_search = function (bank_type) {
    sell_list_search($scope, bank_type);
  };
  $scope.sell_company_list_search = function (bank_type) {
    sell_company_list_search($scope, bank_type);
  };
  $scope.screenings_search = function () {
    if ($scope.screeningResultFundJson.length > 0) {
      let data_list = [];
      $scope.result = {};
      for (let i in $scope.optionData.item_num_list) {
        data_list.push("[" + $scope.optionData.item_num_list[i] + "]");
      }
      $('.search_form input[name="option_list"]').val(
        $scope.optionData.id_list
      );
      $('.search_form input[name="data_list"]').val(data_list);
      $.ajax({
        url: "/fund_detail_searches",
        type: "post",
        async: true,
        cache: false,
        dataType: "json",
        data: $(".search_form").serialize(),
        success: function (data) {
          if (data && data.short_code) {
            const url = new URL(location);
            url.searchParams.set("short_code", data.short_code);
            history.pushState({}, "", url);
            // $('<input />')
            //   .attr('type', 'hidden')
            //   .attr('name', 'short_code')
            //   .attr('value', data.short_code)
            //   .appendTo('.search_form')
            // $('.search_form').submit()
            window.location.href = '/fund_detail_searches/' + data.short_code;
          }
          return true;
        },
        error: function () {
          return false;
        },
      });
    }
  };
  $scope.all_clear = function (data) {
    $scope.optionJson = angular.copy(scope.optionJson);
    initOptionData($scope);
    $scope.screeningFundJson = [];
    $scope.screeningResultFundJson = [];
    clearSellBankAndCompany($scope, "sell_bank");
    clearSellBankAndCompany($scope, "company");
    for (let i = 0; i < $scope.charts.length; i++) {
      $scope.charts[i].clear();
    }
    showResultVal($scope);
  };
  $scope.check_less_year = function (ind) {
    check_less_year($scope, ind);
  };
  let option_ids = [1301, 1401, 1501, 1303, 1403, 1503, 1305, 1405, 1505];
  $scope.charts = [];
  for (let i = 0; i < option_ids.length; i++) {
    let option = null;
    for (let j = 0; j < $scope.optionJson.length; j++) {
      if ($scope.optionJson[j].option_id == option_ids[i]) {
        option = $scope.optionJson[j];
        break;
      }
    }
    // ie is not support 'find'
    // let option = $scope.optionJson.find(function(v) {return v.option_id == option_ids[i]});
    let chart_div = document.getElementById("chart_" + option_ids[i]);
    if (chart_div) {
      let myChart = new BlockChart(chart_div);
      if (myChart) {
        myChart.setParams(option);
        myChart.init(block_charts_option_list, block_charts_data_list);
        myChart.draw();
        myChart.change = function (option, start, end) {
          clearData(option, $scope);
          for (let ii = start; ii <= end; ii++) {
            pushData(option, option.data[ii], $scope);
          }
          detailScreeningFund($scope);
          showResultVal($scope);
        };
        $scope.charts.push(myChart);
      }
    }
  }
}

function clearSellBankAndCompany($scope, bank_type) {
  if (bank_type == "sell_bank") {
    $scope.sell_bank_input = "";
    $scope.sell_bank_exist = [];
  } else {
    $scope.company_input = "";
    $scope.company_exist = [];
    $scope.company_select = [];
  }
  $.each($scope[bank_type + "_type_json"], function (i) {
    let json_data = $scope[bank_type + "_type_json"][i].data;
    $.each(json_data, function (j) {
      check_box_null(json_data[j]);
    });
    if (bank_type) {
      check_box_null($scope[bank_type + "_type_json"][i]);
    }
  });
}

search_detail_app.controller("detail_controller", [
  "$scope",
  "scope",
  function ($scope, scope) {
    getJson(
      $('.pageCon_search').data('searchDetailUrl'),
      scope.optionJson,
      {
        async: true,
        callbackParams: { p1: $scope, p2: scope },
        callback: afterJsonCallback,
      }
    );
    getJson(
      $('.pageCon_search').data('searchDetailFundsUrl'),
      scope.fundJson,
      {
        async: true,
        callbackParams: { p1: $scope, p2: scope },
        callback: afterJsonCallback,
      }
    );
    getJson(
      $('.pageCon_search').data('sellBankUrl'),
      scope.getSellBankJson,
      {
        async: true,
        callbackParams: { p1: $scope, p2: scope },
        callback: afterJsonCallback,
      }
    );
    initOptionJson($scope, scope);
  },
]);

// When the radio button is clicked for less than one year
function check_less_year($scope, ind) {
  let option = $scope.optionJson[ind];
  clearData(option, $scope);
  check_box_class($scope, option, ind);
  if (option.checked) pushData(option, {}, $scope);
  if ($scope.optionData.id_list) {
    for (let i = 0; i < $scope.optionData.id_list.length; i++) {
      let option_id = $scope.optionData.id_list[i];
      if (option_id >= 1701 && option_id <= 1705) {
        $scope.optionData.item_num_list[i] = ["1"];
      }
    }
  }
  detailScreeningFund($scope);
  showResultVal($scope);
}

// bank search delete button
function del_bank_name($scope, bank_type, data) {
  let exist_idx = $scope[bank_type + "_exist"].indexOf(data);
  if (exist_idx !== -1) $scope[bank_type + "_exist"].splice(exist_idx, 1);
  let clear_flag = false;
  // After pressing the clear button, synchronously clear the list check style
  $.each($scope[bank_type + "_type_json"], function (i) {
    let json_data = $scope[bank_type + "_type_json"][i].data;
    $.each(json_data, function (j) {
      if (json_data[j].id === data.id) {
        check_box_null(json_data[j]);
        json_data[j].checked = "false";
        clear_flag = true;
        return false;
      }
    });
    if (clear_flag) {
      if (bank_type) {
        check_box_null($scope[bank_type + "_type_json"][i]);
        $scope[bank_type + "_type_json"][i].checked = "false";
      }
      return false;
    }
  });
  sell_bank_push($scope, bank_type);
}

// Confirmation method of club list, add it to global letiable
function sell_list_search($scope, bank_type) {
  let keys_a = Object.keys($scope[bank_type + "_type_json"]);
  $.each(keys_a, function (i) {
    let data = $scope[bank_type + "_type_json"][keys_a[i]].data;
    $.each(data, function (j) {
      if (data[j].li_class == 'active') {
        sell_select_search($scope, data[j], bank_type, false);
      } else {
        $.each($scope[bank_type + "_exist"], function (x, existData) {
          if (existData && existData.id == data[j].id) {
            $scope[bank_type + "_exist"].splice(x, 1);
            return;
          }
        });
      }
    });
  });
  sell_bank_push($scope, bank_type);
  $(".detail_company_popup").hide();
}

function sell_company_list_search($scope, bank_type) {
  let data = $scope[bank_type + "_select"];
  $.each(data, function (i) {
    if (data[i].checked) {
      let tmpData = data[i];
      tmpData.id = data[i].bank_id;
      sell_select_search($scope, tmpData, bank_type, false);
      $.each($scope[bank_type + "_type_json"], function (j, t_data) {
        $.each(t_data.data, function (j, json_data) {
          if (json_data.id == tmpData.id) {
            check_box_class($scope, json_data);
          }
        });
      });
    } else {
      if ($scope[bank_type + "_exist"].indexOf(data[i]) !== -1)
        $scope[bank_type + "_exist"].splice(
          $scope[bank_type + "_exist"].indexOf(data[i]),
          1
        );
    }
  });

  allSelectBySellBankAndCompany($scope, bank_type);
  sell_bank_push($scope, bank_type);
  $(".detail_company_popup").hide();
}

// sell_bank or company all select(sp)
function allSelectBySellBankAndCompany($scope, bank_type) {
  $.each($scope[bank_type + "_type_json"], function (i) {
    let allFlag = true;
    let json_data = $scope[bank_type + "_type_json"][i].data;
    $.each(json_data, function (j) {
      if (!json_data[j].checked) {
        allFlag = false;
      }
    });
    if (allFlag) {
      check_box_active($scope[bank_type + "_type_json"][i]);
    } else {
      check_box_null($scope[bank_type + "_type_json"][i]);
    }
  });
}

// Click to change the class of the radio
function sell_bank_i($scope, data, bank_type) {
  if (data.data !== undefined) {
    if (data.li_class != "active") {
      check_box_active(data);
      $.each(data.data, function (i) {
        check_box_active(data.data[i]);
      });
    } else {
      check_box_null(data);
      $.each(data.data, function (i) {
        check_box_null(data.data[i]);
      });
    }
  } else {
    check_box_class($scope, data);
    allSelectBySellBankAndCompany($scope, bank_type);
  }
}

// bank search func
function sell_bank_push($scope, bank_type) {
  let ind = 25;
  if (bank_type === "company") ind = 24;
  let option = $scope.optionJson[ind];
  clearData(option, $scope);
  $.each($scope[bank_type + "_exist"], function (i) {
    pushData(option, $scope[bank_type + "_exist"][i], $scope);
  });
  detailScreeningFund($scope);
  showResultVal($scope);
}

function sell_select_search($scope, data, bank_type, push_end) {
  if (data.id !== undefined && data.id !== "desc") {
    let new_bank_flag = true;
    if ($scope[bank_type + "_exist"].length > 0) {
      for (let j = 0; j < $scope[bank_type + "_exist"].length; j++) {
        if (data.id === $scope[bank_type + "_exist"][j].id) {
          new_bank_flag = false;
          break;
        }
      }
    }

    if (new_bank_flag) $scope[bank_type + "_exist"].push(data);

    if (push_end === true) {
      sell_bank_push($scope, bank_type);
    }
  }
  $(".detail_company_popup").hide();
}

//Get drop-down box data for bank
function sell_select_open($scope, bank_type) {
  let all_bank_json = $scope.allSellBankJson;
  let text = "販売";
  if (bank_type === "company") {
    all_bank_json = $scope.allCompanyJson;
    text = "運用";
  }
  if (
    $scope[bank_type + "_input"] !== "" &&
    $scope[bank_type + "_input"] !== undefined
  ) {
    $scope[bank_type + "_input"] = toSBC(
      $.trim($scope[bank_type + "_input"].toLowerCase())
    );
    let bank_list = [];
    for (let i = 0; i < all_bank_json.length; i++) {
      let sell_bank_json = all_bank_json[i];
      check_exist_select(
        $scope[bank_type + "_input"],
        sell_bank_json,
        $scope[bank_type + "_exist"],
        bank_list
      );
    }
    let html = [];
    if (bank_list.length > 0) {
      //html.push({bank_id: 'desc', bank_name: '該当：'+ bank_list.length +'件：以下より選択してください。'});
      for (let i = 0; i < bank_list.length; i++) {
        html.push({ bank_id: bank_list[i][0], bank_name: bank_list[i][1] });
      }

      $scope[bank_type + "_select"] = html;
      $scope[bank_type + "_select_val"] = "desc";
      $("#" + bank_type + "_select_show").show();
    } else {
      //html.push({bank_id: 'desc', bank_name: '検索キーワードでの該当ファンドを見つかりませんでした'});
      $("#" + bank_type + "_blank_show").show();
      $("#" + bank_type + "_blank_show")
        .find(".detail_company_popup_btn span:first-child")
        .click(function () {
          $("#" + bank_type + "_blank_show").hide();
        });
      $("#" + bank_type + "_blank_show")
        .find(".detail_company_popup_btn span:last-child")
        .click(function () {
          $("#" + bank_type + "_blank_show").hide();
        });
    }
  } else {
    alert(text + "会社を入力してください。");
  }
}
// When you click the club search, the data in the drop-down box
function check_exist_select(input_text, bank_josn, exist_bank, bank_list) {
  let bank_id = bank_josn[0];
  let bank_name = bank_josn[1] ? toSBC(bank_josn[1].toLowerCase()) : "";
  let bank_name2 = bank_josn[2] ? toSBC(bank_josn[2].toLowerCase()) : "";
  let new_bank_flag = true;

  if (exist_bank.length > 0) {
    for (let j = 0; j < exist_bank.length; j++) {
      if (bank_id === exist_bank[j].id) {
        new_bank_flag = false;
        break;
      }
    }
  }
  if (new_bank_flag) {
    if (
      bank_name.indexOf(input_text) !== -1 ||
      bank_name2.indexOf(input_text) !== -1
    ) {
      bank_list.push(bank_josn);
    }
  }
}

function check_box_class($scope, data, ind) {
  if (ind !== 9) {
    if (!data.checked) {
      check_box_active(data);
    } else {
      check_box_null(data);
    }
  } else {
    // Separate treatment of radio: 信託財産留保額
    if (data.li_class == null) {
      data.li_class = "active";
      data.icon_class = "icon-radio-checked";
      let option = $scope.optionJson[ind].data;
      $.each(option, function (i) {
        if (option[i].id !== data.id) {
          option[i].li_class = null;
          option[i].icon_class = "icon-radio-unchecked";
        }
      });
    } else {
      data.li_class = null;
      data.icon_class = "icon-radio-unchecked";
    }
  }
}
function check_box_active(data) {
  data.li_class = "active";
  data.checked = true;
}
function check_box_null(data) {
  data.li_class = null;
  data.checked = false;
}

function check_box_click(ind, data, $scope) {
  let option = $scope.optionJson[ind];
  clearData(option, $scope);
  check_box_class($scope, data, ind);
  if ([5, 6, 27].indexOf(ind) > -1 && data) {
    if ((data.li_class = "active")) {
      if (data.name === "なし") {
        data.class = "text-itf-gray-dark";
      } else {
        data.class = "text-[#DBBD15]";
      }
    } else {
      data.class = "";
    }
  }
  $.each(option.data, function (i) {
    if (option.data[i].checked) {
      if (ind === 9 && i === 2) {
        pushData(option, option.data[0], $scope);
        pushData(option, option.data[1], $scope);
      } else {
        pushData(option, option.data[i], $scope);
      }
    }
  });
  detailScreeningFund($scope);
  showResultVal($scope);
}

function clearData(option, $c) {
  let idx = getOptionIdx(option, $c);
  $c.optionData.id_list.splice(idx, 1);
  $c.optionData.name_list.splice(idx, 1);
  $c.optionData.item_num_list.splice(idx, 1);
}

function pushData(option, data_o, $c) {
  // let option_id = option.option_id
  let idx = getOptionIdx(option, $c);
  let data = data_o.id;

  if (typeof data == "number") {
    if ($.inArray(data, $c.optionData.item_num_list[idx]) == -1)
      $c.optionData.item_num_list[idx].push(data.toString());
  } else if (typeof data == "string") {
    if (data.indexOf(",") != -1) {
      let tmp_data = data.split(",");
      for (let i in tmp_data) {
        if ($.inArray(tmp_data[i], $c.optionData.item_num_list[idx]) == -1)
          $c.optionData.item_num_list[idx].push(tmp_data[i].toString());
      }
    } else {
      if ($.inArray(data, $c.optionData.item_num_list[idx]) == -1)
        $c.optionData.item_num_list[idx].push(data);
    }
  } else if (typeof data == "object") {
    for (let i in data) {
      if ($.inArray(data[i], $c.optionData.item_num_list[idx]) == -1)
        $c.optionData.item_num_list[idx].push(data[i].toString());
    }
  }
  return $c;
}
function getOptionIdx(option, $c) {
  let option_id = option.option_id;
  let idx = $c.optionData.id_list.indexOf(option_id);
  if (idx == -1) {
    let option_name = option.name;
    $c.optionData.id_list.push(option_id);
    $c.optionData.name_list.push(option_name);
    $c.optionData.item_list.push([]);
    $c.optionData.item_num_list.push([]);
    idx = $c.optionData.id_list.indexOf(option_id);
  }
  return idx;
}

// count show
function showResultVal($c) {
  if ($c.showResultValFlag) {
    let old_val = $(".screenings_num").val();
    let new_val = $c.screeningResultFundJson.length;
    animationNum($(".screenings_num"), old_val, new_val);
    animationNum($(".screenings_numFixed"), old_val, new_val);

    if (new_val === 0) {
      $(".search_conditions")
        .attr("disabled", true)
        .addClass("bg-[#ccc] border-[#ccc] cursor-not-allowed pointer-events-none");
      $(".screenings_search")
        .attr("disabled", true)
        .addClass("bg-[#ccc] border-[#ccc] cursor-not-allowed pointer-events-none");
      $(".search_fixed_btn").attr("disabled", true).addClass("bg-[#ccc] border-[#ccc] cursor-not-allowed pointer-events-none");
    } else {
      $(".search_conditions")
        .attr("disabled", false)
        .removeClass("bg-[#ccc] border-[#ccc] cursor-not-allowed pointer-events-none");
      $(".screenings_search")
        .attr("disabled", false)
        .removeClass("bg-[#ccc] border-[#ccc] cursor-not-allowed pointer-events-none");
      $(".search_fixed_btn")
        .attr("disabled", false)
        .removeClass("bg-[#ccc] border-[#ccc] cursor-not-allowed pointer-events-none");
    }
    $(".pageCon_search .loading").addClass("hidden");
    $(".pageCon_search .detail_condition_content").removeClass("hidden");
  }
}

$(document).ready(function () {
  let detailSearch = {
    init: function () {
      let $c = this;

      // $('.pageCon_search .loading').remove()
      // $('.pageCon_search .detail_condition_content').removeClass('hidden')

      setTimeout(function () {
        $c.initResultFloatingLayer();
      }, 500);
    },

    // Init result floating layout
    initResultFloatingLayer: function () {
      let $c = this;
      $c.hideResultFloatingLayer();
      let bottom_btn = $(".screenings_btnGroup");
      if (bottom_btn.length == 0) { return }

      let bottom_btn_top = bottom_btn.offset().top;
      // If detail content height > 1000 then show floating layout
      if ($(".pageCon_search").height() > 1000) {
        $c.showResultFloatingLayer();
        let fix_top = $(".search_fixed").position().top;
        if ($(".pageCon_search").hasClass("sp")) {
          // 150 is top nav
          $(window).scroll(function () {
            let search_sell_tag = $(".search_sell_tag").height();
            let search_company_tag = $(".search_company_tag").height();
            $(window).scrollTop() >
            bottom_btn_top +
              search_sell_tag +
              search_company_tag -
              fix_top -
              150
              ? $c.hideResultFloatingLayer()
              : $c.showResultFloatingLayer();
          });
        } else {
          $(window).scroll(function () {
            let search_sell_tag = $(".search_sell_tag").height();
            let search_company_tag = $(".search_company_tag").height();
            $(window).scrollTop() >
            bottom_btn_top + search_sell_tag + search_company_tag - fix_top
              ? $c.hideResultFloatingLayer()
              : $c.showResultFloatingLayer();
          });
        }
      }
    },
    hideResultFloatingLayer: function () {
      $(".search_fixed").addClass("hidden");
      $(".screenings_btnGroup").removeClass("hidden");
    },
    showResultFloatingLayer: function () {
      $(".search_fixed").removeClass("hidden");
      $(".screenings_btnGroup").addClass("hidden");
    },
  };
  detailSearch.init();

  //販売会社一覧から選択-layer-scrollBar
  $(".company_scrollBar").mCustomScrollbar({
    scrollInertia: 150,
  });
  //keywords search
  $(".company_search_scrollBar").mCustomScrollbar({
    scrollInertia: 150,
  });
  // tooltip
  $(".detail_list_title").on("click", function (e) {
    e.stopPropagation();
    if ($(".pageCon_search").hasClass("sp")) {
      $(this).nextAll(".detail_list_dialog").fadeToggle();
      $(this).parent().siblings(".rlt").find(".detail_list_dialog").hide();
      $(this)
        .parents()
        .siblings(".ly_content_wrapper")
        .find(".detail_list_dialog")
        .hide();
    } else {
      let hl = $(this).height() / 2;
      let hs = $(this).children("span").height() / 2 + 5;

      $(this)
        .nextAll(".detail_list_dialog")
        .css("bottom", hl - hs);

      $(this).nextAll(".detail_list_dialog").fadeToggle();
      $(this)
        .parent()
        .siblings(".brd_bottom")
        .find(".detail_list_dialog")
        .hide();
      $(this)
        .parents()
        .siblings(".ly_content_wrapper")
        .find(".detail_list_dialog")
        .hide();
    }
  });
  $("body").on("click", function () {
    if ($(".pageCon_detailed .detail_list_dialog").is(":visible")) {
      $(".detail_list_dialog").hide();
    }
  });
});

function animationNum(obj, old, now) {
  obj.prop("number", old).animateNumber(
    {
      number: now,
    },
    300
  );
}

// Half-angle to full-angle
function toSBC(str) {
  let result = "";
  let len = str.length;
  for (let i = 0; i < len; i++) {
    let cCode = str.charCodeAt(i);
    // The difference between full and half angles (except blanks): 65248 (Decimal system)
    cCode = cCode >= 0xff01 && cCode <= 0xff5e ? cCode - 65248 : cCode;
    // Processing space
    cCode = cCode == 0x03000 ? 0x0020 : cCode;
    result += String.fromCharCode(cCode);
  }
  return result;
}
